import { networkService as network } from '@/services'

export const roleService = {
  getRoles() {
    return new Promise((resolve, reject) => {
      network
        .get(`/roles/all`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}